import {
  formatLocalDateOnly,
  formatLocalDateTime,
  normalizeInclusiveRangeEndIso,
} from '../../../util/dateUtils'

export const SeverityMap = {
  1: 'low',
  2: 'medium',
  3: 'critical',
} as const

export const formatDate = (dateString: string): string => {
  return formatLocalDateTime(dateString)
}

export const formatDateOnly = (dateString: string): string => formatLocalDateOnly(dateString)

export const formatDateRangeEnd = (dateString: string): string =>
  formatLocalDateTime(normalizeInclusiveRangeEndIso(dateString) ?? dateString)

export const getSeverityColor = (severity: number, opacity: number) => {
  switch (severity) {
    case 1:
      return `rgba(255, 193, 36, ${opacity})`
    case 2:
      return `rgba(255, 159, 64, ${opacity})`
    case 3:
      return `rgba(241, 69, 106, ${opacity})`
  }
  return 'rgb(0, 0, 0)'
}

export const getSeverityTextColor = (severity: number, active = false) => {
  switch (severity) {
    case 1:
      return 'rgb(134, 96, 0)'
    case 2:
      return 'rgb(139, 70, 0)'
    case 3:
      return active ? 'rgb(255, 41, 88)' : 'rgb(255, 255, 255)'
  }
  return 'rgb(0, 0, 0)'
}
